import React from 'react';
import ReactDOM from 'react-dom';

import App from './app';
import './config/i18n';
import './scss/application.scss';
import { register } from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

register();
